import { useState, useEffect, useRef } from "react";
import "./GlobalDashBoardComponents.css";
import TextWithTooltip from "../../../GlobalContacts/TextWithTooltip";
import { findCompanyDetails } from "../../../../../services/iqApiV2";
function ChipsDropdown({
  selectedValues,
  setSelectedValues,
  placeholder,
  inputType = "text",
  validateInput,
}) {
  const [inputValue, setInputValue] = useState("");
  const inputRef = useRef(null);

  const handleAddChip = (item) => {
    if (!selectedValues?.find((v) => v.id === item.id)) {
      const newSelected = [...selectedValues, item];
      setSelectedValues(newSelected);
    }
    setInputValue("");
  };

  const handleRemoveChip = (id) => {
    const newSelected = selectedValues.filter((v) => v.id !== id);
    setSelectedValues(newSelected);
  };

  const handleInputChange = (e) => {
    let value = e.target.value;

    // ✅ Allow only numbers if inputType is "numberOnly"
    if (inputType === "numberOnly") {
      value = value.replace(/\D/g, ""); // remove non-digit characters
    }

    setInputValue(value);
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter" && inputValue.trim()) {
      const trimmedValue = inputValue.trim();

      // ✅ Generic validation
      if (validateInput && !validateInput(trimmedValue)) {
        setInputValue(""); // clear invalid input
        return; // skip adding chip
      }

      handleAddChip({ id: trimmedValue, label: trimmedValue });
      e.preventDefault();
    }
    if (
      e.key === "Backspace" &&
      inputValue === "" &&
      selectedValues?.length > 0
    ) {
      const lastChip = selectedValues[selectedValues?.length - 1];
      handleRemoveChip(lastChip.id);
      e.preventDefault();
    }
  };

  return (
    <div
      className="checkbox-chips-dropdown-container"
      onClick={() => inputRef.current?.focus()}
    >
      {selectedValues?.map((chip) => (
        <div key={chip.id} className="chip_gcsf gray">

          <TextWithTooltip className="chip-label" text = {inputType === "numberOnly"
            ? Math.round(parseFloat(chip.label))
            : chip.label}/>
          <button
            className="chip-close"
            onClick={(e) => {
              e.stopPropagation();
              handleRemoveChip(chip.id);
            }}
          >
            &times;
          </button>
        </div>
      ))}

      <input
        ref={inputRef}
        type="text"
        placeholder={selectedValues?.length === 0 ? placeholder : ""}
        className="chip-input"
        value={inputValue}
        onChange={handleInputChange}
        onKeyDown={handleKeyDown}
        style={{

          fontSize: "12.8px",
          color: "#606A74",

        }}
      />
    </div>
  );
}
function CheckboxChipsDropdown({
  options,
  selectedValues,
  setSelectedValues,
  placeholder,
}) {
  const [isOpen, setIsOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const dropdownRef = useRef(null);
  const inputRef = useRef(null);

  const handleToggleOption = (option) => {
    if (selectedValues?.find((v) => v.id === option.id)) {
      setSelectedValues(selectedValues?.filter((v) => v.id !== option.id));
    } else {
      setSelectedValues([...selectedValues, option]);
    }
    setSearchTerm("");
  };

  const handleRemoveChip = (id) => {
    setSelectedValues(selectedValues?.filter((v) => v.id !== id));
  };

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setIsOpen(false);
        setSearchTerm(""); // clear search when closing
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  // Filter options by search term
  const filteredOptions = options?.filter((opt) =>
    opt.label.toLowerCase()?.includes(searchTerm?.toLowerCase())
  );

  return (
    <div
      className="checkbox-chips-dropdown-container"
      ref={dropdownRef}
      onClick={(e) => {
        e.stopPropagation();
        inputRef.current?.focus();
        setIsOpen((prev) => !prev);
      }}
    >
      {/* Selected Chips */}
      {selectedValues?.map((chip) => (
        <div key={chip.id} className="chip_gcsf gray">

          <TextWithTooltip
            className="chip-label"
            text={chip.label.charAt(0).toUpperCase() + chip.label.slice(1)}
          />

          <button
            className="chip-close"
            onClick={(e) => {
              e.stopPropagation();
              handleRemoveChip(chip?.id);
            }}
          >
            &times;
          </button>
        </div>
      ))}

      {/* Search / Placeholder Input */}
      <input
        ref={inputRef}
        type="text"
        value={searchTerm}
        onChange={(e) => {
          setSearchTerm(e.target.value);
          if (!isOpen) setIsOpen(true); // open dropdown when typing
        }}
        placeholder={
          selectedValues?.length === 0 && !searchTerm ? placeholder : ""
        }
        onClick={(e) => {
          e.stopPropagation();
          setIsOpen((prev) => !prev);
        }}
        style={{
          flex: 1,
          border: "none",
          outline: "none",
          minWidth: "50px",
          fontSize: "12.8px",
          color: "#606A74",
          paddingRight: "1.5rem",
          background: "transparent",
        }}
      />

      {/* Chevron Icon */}
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        viewBox="0 0 24 24"
        style={{
          position: "absolute",
          right: "0.25rem",

          top: "50%",
          transform: isOpen
            ? "translateY(-50%) rotate(180deg)"
            : "translateY(-50%)",
          transition: "transform 0.2s ease",
          pointerEvents: "none",
        }}
      >
        <path d="M6 9l6 6 6-6"></path>
      </svg>

      {/* Dropdown List */}
      {isOpen && (
        <div
          className="dropdown-list"
          style={{
            position: "absolute",
            top: "calc(100% + 4px)",
            left: 0,
            width: "100%",
            backgroundColor: "#fff",
            border: "1px solid #ccc",
            borderRadius: "6px",
            boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
            zIndex: 10,
            maxHeight: "220px",
            overflowY: "auto",
          }}
          onClick={(e) => e.stopPropagation()}
        >
          {filteredOptions?.length > 0 ? (
            filteredOptions?.map((opt) => (
              <label
                key={opt?.id}
                className="dropdown-item-gdc"

                onClick={(e) => e.stopPropagation()}
              >
                <input
                  type="checkbox"
                  checked={selectedValues?.some((v) => v.id === opt.id)}
                  onChange={() => handleToggleOption(opt)}
                  style={{ marginRight: "10px" }}
                />
                {/* {opt.label} */}
                <span className="dropdown-item-gdc-text">{opt.label.replace(/_/g, '-')}</span>

              </label>
            ))
          ) : (
            <div
              style={{
                padding: "8px 10px",
                fontSize: "12.8px",
                color: "#606A74",
                textAlign: "center",
              }}
            >
              Please Search
            </div>
          )}
        </div>
      )}
    </div>
  );
}


function SearchDropdown({
  selectedValues,
  setSelectedValues,
  placeholder,
}) {
  const [isOpen, setIsOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [options, setOptions] = useState([]);
  const [loading, setLoading] = useState(false);
  const dropdownRef = useRef(null);
  const inputRef = useRef(null);

  const handleToggleOption = (option) => {
    if (selectedValues?.find((v) => v.id === option.id)) {
      setSelectedValues(selectedValues?.filter((v) => v.id !== option.id));
    } else {
      setSelectedValues([...selectedValues, option]);
    }
    setSearchTerm("");
  };

  const handleRemoveChip = (id) => {
    setSelectedValues(selectedValues?.filter((v) => v.id !== id));
  };

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setIsOpen(false);
        setSearchTerm("");
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);


  useEffect(() => {
    const fetchContacts = async () => {
      // if (!searchTerm || searchTerm.length < 2) {
      //   setOptions([]);
      //   return;
      // }

      setLoading(true);
      try {
        const payload = {
          additionalProp1: {
            q_organization_name: searchTerm,
          },
        };

        if (searchTerm?.length>0) {
          const response = await findCompanyDetails(payload);

          const formatted = response.map((c) => ({
            id: c.name,
            label: c.name || c.organization_name || "Unnamed Contact",
          }));

          setOptions(formatted);
        }
      } catch (err) {
        console.error("Error fetching contacts:", err);
        setOptions([]);
      } finally {
        setLoading(false);
      }
    };

    const delayDebounce = setTimeout(fetchContacts, 500); // debounce API call
    return () => clearTimeout(delayDebounce);
  }, [searchTerm]);

  return (
    <div
      className="checkbox-chips-dropdown-container"
      ref={dropdownRef}
      onClick={(e) => {
        e.stopPropagation();
        inputRef.current?.focus();
        setIsOpen((prev) => !prev);
      }}
    >
      {/* Selected Chips */}
      {selectedValues?.map((chip) => (
        <div key={chip.id} className="chip_gcsf gray">
          <TextWithTooltip className="chip-label" text={chip.label} />
          <button
            className="chip-close"
            onClick={(e) => {
              e.stopPropagation();
              handleRemoveChip(chip?.id);
            }}
          >
            &times;
          </button>
        </div>
      ))}

      {/* Search / Placeholder Input */}
      <input
        ref={inputRef}
        type="text"
        value={searchTerm}
        onChange={(e) => {
          setSearchTerm(e.target.value);
          if (!isOpen) setIsOpen(true);
        }}
        placeholder={
          selectedValues?.length === 0 && !searchTerm ? placeholder : ""
        }
        onClick={(e) => {
          e.stopPropagation();
          setIsOpen((prev) => !prev);
        }}
        style={{
          flex: 1,
          border: "none",
          outline: "none",
          minWidth: "50px",
          fontSize: "12.8px",
          color: "#606A74",
          paddingRight: "1.5rem",
          background: "transparent",
        }}
      />

      {/* Chevron Icon */}
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        viewBox="0 0 24 24"
        style={{
          position: "absolute",
          right: "0.5rem",
          top: "50%",
          transform: isOpen
            ? "translateY(-50%) rotate(180deg)"
            : "translateY(-50%)",
          transition: "transform 0.2s ease",
          pointerEvents: "none",
        }}
      >
        <path d="M6 9l6 6 6-6"></path>
      </svg>

      {/* Dropdown List */}
      {isOpen && (
        <div
          className="dropdown-list"
          style={{
            position: "absolute",
            top: "calc(100% + 4px)",
            left: 0,
            width: "100%",
            backgroundColor: "#fff",
            border: "1px solid #ccc",
            borderRadius: "6px",
            boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
            zIndex: 10,
            maxHeight: "220px",
            overflowY: "auto",
          }}
          onClick={(e) => e.stopPropagation()}
        >
          {loading ? (
            <div style={{ padding: "8px 10px", textAlign: "center" ,fontSize: "12.8px",color: "#606A74",}}>
              Loading...
            </div>
          ) : options?.length > 0 ? (
            options.map((opt) => (
              <label
                key={opt?.id}
                className="dropdown-item-gdc"
                style={{
                  display: "flex",
                  alignItems: "center",
                  cursor: "pointer",
                  padding: "6px 10px",
                }}
                onClick={(e) => e.stopPropagation()}
              >
                <input
                  type="checkbox"
                  checked={selectedValues?.some((v) => v.id === opt.id)}
                  onChange={() => handleToggleOption(opt)}
                  style={{ marginRight: "10px" }}
                />
                {opt.label}
              </label>
            ))
          ) : (
            <div
              style={{
                padding: "8px 10px",
                fontSize: "12.8px",
                color: "#606A74",
                textAlign: "center",
              }}
            >
              Please Search
            </div>
          )}
        </div>
      )}
    </div>
  );
}




export { ChipsDropdown, CheckboxChipsDropdown, SearchDropdown};
